import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { useMaintenanceMode } from "../context/MaintenanceContext";
import { useTheme } from "@mui/material"; // ✅ ADD THIS
import { useThemeContext } from "../context/ThemeContext"; // ✅ ADD THIS
import OfflineBar from "../components/utilities/OfflineBar";
import {
  Box,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import athrvLogo from "../img/Athrv-white.png";
import athrvLogoDark from "../img/Athrv-white.png";
import awsLogo from "../img/aws.png";
import "../styles/login.css";
import awsLogoWhite from "../img/aws-main.png";

const Eye = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const EyeOff = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
    <line x1="1" y1="1" x2="23" y2="23"></line>
  </svg>
);



// Custom TextField component
const CustomTextField = ({ 
  label, 
  type, 
  field, 
  value, 
  onChange, 
  onBlur, 
  onKeyDown,
  error,
  touched,
  isLargeScreen,
  isDarkMode
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const hasValue = value && value.length > 0;
  const hasError = touched && error;

  // Determine actual input type
  const inputType = type === 'password' && !showPassword ? 'password' : 'text';
  const isPasswordField = type === 'password';


  return (
    <div className={`text-field-container ${isLargeScreen ? 'large' : ''}`}>
      <div style={{ position: 'relative' }}>
        <input
          type={inputType}
          value={value}
          placeholder={label}
          className={`text-field-input ${isLargeScreen ? 'large' : ''} ${hasError ? 'error' : ''} ${isPasswordField ? 'with-icon' : ''}`}
          onChange={(e) => onChange(field, e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => {
            setIsFocused(false);
            onBlur(field);
          }}
          onKeyDown={onKeyDown}
          autoComplete={type === 'email' ? 'email' : 'current-password'}
        />
        {isPasswordField && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className={`password-toggle-btn ${isLargeScreen ? 'large' : ''}`}
            tabIndex={-1}
          >
            {showPassword ? <Eye size={isLargeScreen ? 24 : 20} /> : <EyeOff size={isLargeScreen ? 24 : 20} />}
          </button>
        )}
      </div>
      {hasError && (
        <p className={`text-field-error ${isLargeScreen ? 'large' : ''}`}>
          {error}
        </p>
      )}
    </div>
  );
};

// Icon Components

const Shield = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
);

const DevOps = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.6,6.62C21.58,6.62 24,9 24,12C24,14.96 21.58,17.37 18.6,17.37C17.15,17.37 15.8,16.81 14.78,15.8L12,13.34L9.17,15.85C8.2,16.82 6.84,17.38 5.4,17.38C2.42,17.38 0,14.96 0,12C0,9.04 2.42,6.62 5.4,6.62C6.84,6.62 8.2,7.18 9.17,8.15L12,10.66L14.83,8.2C15.8,7.18 17.15,6.62 18.6,6.62M7.8,14.39L10.5,12L7.84,9.65C7.16,8.97 6.31,8.62 5.4,8.62C3.53,8.62 2,10.13 2,12C2,13.87 3.53,15.38 5.4,15.38C6.31,15.38 7.16,15.03 7.8,14.39M16.2,9.61L13.5,12L16.16,14.35C16.84,15.03 17.7,15.37 18.6,15.37C20.47,15.37 22,13.87 22,12C22,10.13 20.47,8.62 18.6,8.62C17.7,8.62 16.84,8.97 16.2,9.61Z" />
  </svg>
);

const Settings = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 3v3m6.366-.366-2.12 2.12M21 12h-3m.366 6.366-2.12-2.12M12 21v-3m-6.366.366 2.12-2.12M3 12h3m-.366-6.366 2.12 2.12"></path>
  </svg>
);

const Moon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
  </svg>
);

const Sun = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="5"></circle>
    <line x1="12" y1="1" x2="12" y2="3"></line>
    <line x1="12" y1="21" x2="12" y2="23"></line>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
    <line x1="1" y1="12" x2="3" y2="12"></line>
    <line x1="21" y1="12" x2="23" y2="12"></line>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
  </svg>
);

const FeatureCard = ({ icon: Icon, title, description, isLargeScreen }) => (
  <div className={`feature-card ${isLargeScreen ? 'large' : ''}`}>
    <div className={`feature-icon ${isLargeScreen ? 'large' : ''}`}>
      <Icon size={isLargeScreen ? 36 : 26} />
    </div>
    <div>
      <h3 className={`feature-title ${isLargeScreen ? 'large' : ''}`}>
        {title}
      </h3>
      <p className={`feature-description ${isLargeScreen ? 'large' : ''}`}>
        {description}
      </p>
    </div>
  </div>
);

const LoginPage = () => {
  // ✅ USE GLOBAL THEME
  const theme = useTheme();
  const { toggleTheme } = useThemeContext(); // ✅ GET GLOBAL TOGGLE FUNCTION
  const isDarkMode = theme.palette.mode === "dark";

  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [error, setError] = useState(null);
  const [showOfflineBar, setShowOfflineBar] = useState(false);
  const [showBackOnlineBar, setShowBackOnlineBar] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;
  const isDesktop = windowWidth >= 1024 && windowWidth < 1500;
  const isLargeScreen = windowWidth >= 1500;
  
  const { checkMaintenanceStatus } = useMaintenanceMode();
  
  const navigate = useNavigate();
  const { isAuthenticated, login, loading } = useAuth();

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      navigate("/dashboard");
    }

    const rememberMe = localStorage.getItem("remember_me");
    const savedEmail = localStorage.getItem("saved_email");
    
    if (rememberMe === "true" && savedEmail) {
      setFormValues(prev => ({
        ...prev,
        email: savedEmail,
        rememberMe: true
      }));
    }
  }, [isAuthenticated, navigate]);

  const validateEmail = (email) => {
    if (!email) return "Email is required";
    if (email.length > 254) return "Email must be less than 254 characters";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return "Please enter a valid email address";
    if (!email.includes(".")) return "Email must contain at least one dot (.)";
    return "";
  };

  const validatePassword = (password) => {
    if (!password) return "Password is required";
    return "";
  };

  const validateForm = () => {
    const newErrors = {
      email: validateEmail(formValues.email),
      password: validatePassword(formValues.password),
    };
    setErrors(newErrors);
    return !newErrors.email && !newErrors.password;
  };

  const handleChange = (field, value) => {
    setFormValues(prev => ({ ...prev, [field]: value }));
    if (touched[field]) {
      const error = field === 'email' ? validateEmail(value) : validatePassword(value);
      setErrors(prev => ({ ...prev, [field]: error }));
    }
  };

  const handleBlur = (field) => {
    setTouched(prev => ({ ...prev, [field]: true }));
    const error = field === 'email' 
      ? validateEmail(formValues[field]) 
      : validatePassword(formValues[field]);
    setErrors(prev => ({ ...prev, [field]: error }));
  };

  let scrollTimeout;
  const handleScroll = (e) => {
    setIsScrolling(true);
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      setIsScrolling(false);
    }, 1000);
  };

  const loginUser = async (email, password) => {
    setShowOfflineBar(false);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/auth/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        console.error("Failed to parse JSON:", jsonError);
        setSnackbarMessage("Server error. Please try again later.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        throw new Error("Server error");
      }

      if (!response.ok) {
        let errorMsg = "Login failed. Please try again.";
        
        if (data.error) {
          errorMsg = data.error;
        } else if (data.msg) {
          errorMsg = data.msg;
        } else if (data.message) {
          errorMsg = data.message;
        } else if (data.detail) {
          errorMsg = data.detail;
        }

        setSnackbarMessage(errorMsg);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        throw new Error(errorMsg);
      }

      login(data.access_token, data.refresh_token, data.fname);
      
      try {
        console.log('Checking maintenance status after login...');
        await checkMaintenanceStatus(data.access_token);
        console.log('Maintenance status check completed');
      } catch (maintenanceError) {
        console.error('Maintenance check failed:', maintenanceError);
      }
      
      return true;

    } catch (err) {
      setError(err.message);
      if (err.message === "No Internet Connection") {
        setShowOfflineBar(true);
      } else if (err.message === "Server under maintenance") {
        // Global error dialog handles this
      } else if (!snackbarOpen) {
        setSnackbarMessage(err.message);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
      return false;
    }
  };

  const confirmLocalStorageItems = () => {
    const token = localStorage.getItem("access_token");
    const fname = localStorage.getItem("fname");
    return token && fname;
  };

  const handleFormSubmit = async () => {
    setTouched({ email: true, password: true });
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const success = await loginUser(formValues.email, formValues.password);

      if (success) {
        if (formValues.rememberMe) {
          localStorage.setItem("remember_me", "true");
          localStorage.setItem("saved_email", formValues.email);
        } else {
          localStorage.removeItem("remember_me");
          localStorage.removeItem("saved_email");
        }

        if (confirmLocalStorageItems()) {
          navigate("/dashboard");
        } else {
          console.error("Local storage items missing. Not redirecting.");
          setSnackbarMessage("Authentication failed. Please try again.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRetry = async () => {
    const success = await loginUser(formValues.email, formValues.password);
    if (success) {
      setShowBackOnlineBar(true);
      setTimeout(() => {
        setShowBackOnlineBar(false);
        navigate("/dashboard");
      }, 3000);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundImage: 'url(/light-mode-background.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className={`login-container ${isMobile ? 'mobile' : ''} ${isTablet ? 'tablet' : ''}`}>
      {/* Overlay */}
      <div className="overlay" />

      {/* ✅ Dark Mode Toggle Button - NOW CONNECTED TO GLOBAL THEME */}
      <button
        onClick={toggleTheme}
        className={`theme-toggle ${isMobile ? 'mobile' : ''} ${isTablet ? 'tablet' : ''} ${isLargeScreen ? 'large' : ''}`}
      >
        {isDarkMode ? <Moon size={isLargeScreen ? 24 : 20} /> : <Sun size={isLargeScreen ? 24 : 20} />}
      </button>

      {/* Main Card Container */}
      <div className={`main-card ${isMobile || isTablet ? 'stacked' : ''} ${isLargeScreen ? 'large' : ''}`}>
        {/* Left Side - Features */}
        {!isMobile && !isTablet && (
          <div className={`features-section ${isLargeScreen ? 'large' : ''}`}>
            {/* Background pattern */}
            <div className="background-pattern" />

            <div className={`features-content ${isLargeScreen ? 'large' : ''}`}>
              {/* Logo */}
              <div className={`logo-container ${isLargeScreen ? 'large' : ''} ${isTablet ? 'tablet' : ''}`}>
                <img 
                  src={isDarkMode ? athrvLogoDark : athrvLogo}
                  alt="Athrv Cloud"
                  className={`logo ${isTablet ? 'tablet' : ''} ${isLargeScreen ? 'large' : ''}`}
                />
              </div>

              {/* Feature Cards */}
              <div>
                <FeatureCard
                  icon={Shield}
                  title="Cybersecurity Solutions"
                  description="AI-powered security and embedded solutions for your infrastructure."
                  isLargeScreen={isLargeScreen}
                />
                
                <FeatureCard
                  icon={DevOps}
                  title="Unified DevOps Platform"
                  description="Streamline development and operations with integrated CI/CD and automation tools."
                  isLargeScreen={isLargeScreen}
                />
                
                <FeatureCard
                  icon={Settings}
                  title="Seamless Integration"
                  description="LLM and AWS powered platform for seamless cloud integration."
                  isLargeScreen={isLargeScreen}
                />
              </div>
            </div>
          </div>
        )}

        {/* Right Side - Login Form */}
        <div 
          className={`form-section ${isMobile || isTablet ? 'full-width' : ''} ${isMobile ? 'mobile' : ''} ${isLargeScreen ? 'large' : ''} ${isScrolling ? 'scrolling' : ''}`}
          onScroll={handleScroll}
        >
          <div className={`form-content ${isLargeScreen ? 'large' : ''}`}>
            <h1 className={`form-title ${isMobile ? 'mobile' : ''} ${isLargeScreen ? 'large' : ''}`}>
              Welcome to Athrv Cloud
            </h1>
            
            <div className={`aws-logo-container ${isLargeScreen ? 'large' : ''}`}>
              {isDarkMode && (
                <span className={`powered-by-text ${isMobile ? 'mobile' : ''} ${isLargeScreen ? 'large' : ''}`}>
                  powered by
                </span>
              )}
              <img
                src={isDarkMode ? awsLogoWhite : awsLogo}
                alt="AWS"
                className={`aws-logo ${isMobile ? 'mobile' : ''} ${isLargeScreen ? 'large' : ''}`}
              />
            </div>

            <CustomTextField
              label="Email ID"
              type="email"
              field="email"
              value={formValues.email}
              onChange={handleChange}
              onBlur={handleBlur}
              onKeyDown={(e) => e.key === 'Enter' && handleFormSubmit()}
              error={errors.email}
              touched={touched.email}
              isLargeScreen={isLargeScreen}
              isDarkMode={isDarkMode}
            />

            <CustomTextField
              label="Password"
              type="password"
              field="password"
              value={formValues.password}
              onChange={handleChange}
              onBlur={handleBlur}
              onKeyDown={(e) => e.key === 'Enter' && handleFormSubmit()}
              error={errors.password}
              touched={touched.password}
              isLargeScreen={isLargeScreen}
              isDarkMode={isDarkMode}
            />

            <div className={`remember-forgot-container ${isLargeScreen ? 'large' : ''}`}>
              <label className={`remember-label ${isMobile ? 'mobile' : ''} ${isLargeScreen ? 'large' : ''}`}>
                <input
                  type="checkbox"
                  checked={formValues.rememberMe}
                  onChange={(e) => handleChange('rememberMe', e.target.checked)}
                  className={`checkbox-input ${isLargeScreen ? 'large' : ''}`}
                />
                Remember Me
              </label>

              <button
                onClick={() => navigate('/forgot-password')}
                className={`forgot-password-btn ${isMobile ? 'mobile' : ''} ${isLargeScreen ? 'large' : ''}`}
              >
                Forgot Password?
              </button>
            </div>

            <button
              onClick={handleFormSubmit}
              disabled={isSubmitting}
              className={`submit-button ${isMobile ? 'mobile' : ''} ${isLargeScreen ? 'large' : ''} ${isSubmitting ? 'disabled' : ''}`}
            >
              {isSubmitting ? 'Logging in...' : 'Login'}
            </button>

            <p className={`signup-link ${isMobile ? 'mobile' : ''} ${isLargeScreen ? 'large' : ''}`}>
              Don't have an account?{' '}
              <button
                onClick={() => navigate('/signup')}
                className="link-text"
              >
                Sign Up
              </button>
            </p>

            <p className={`home-link ${isMobile ? 'mobile' : ''} ${isLargeScreen ? 'large' : ''}`}>
              <a href="https://athrvcloud.com">
                ← Back to Home
              </a>
            </p>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <OfflineBar
        open={showOfflineBar}
        message="No Internet Connection"
        onRetry={handleRetry}
        onClose={() => setShowOfflineBar(false)}
      />
      <OfflineBar
        open={showBackOnlineBar}
        message="Back Online"
        isOnline
        onClose={() => setShowBackOnlineBar(false)}
      />
    </div>
  );
};

export default LoginPage;